export function prefillBookingSection({
  field,
  field: { name },
  userDetail,
  bookingFormFields,
}: {
  field: any;
  userDetail: any;
  bookingFormFields: any;
}): string {
  if (!bookingFormFields[name] || !userDetail?.isLoggedIn) {
    return "";
  }

  if (field?.options?.length > 0 && userDetail[bookingFormFields[name]]) {
    const selectedValue = field.options.find(
      (option) =>
        option.value.toLowerCase() ===
        userDetail[bookingFormFields[name]]?.toLowerCase()
    )?.value;

    if (selectedValue) {
      return selectedValue;
    }
  }

  return userDetail[bookingFormFields[name]];
}
